module.exports = __webpack_public_path__ + "media/images/members/cat-4f2348798c929f2c333779b73c3286fc.png";